// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

//COMPONENT

class SearchBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            input: ''
        };

        this.inputChanged = this.inputChanged.bind(this);
    }

    inputChanged(event){
        this.setState({input: event.target.value});
        this.props.inputChanged(event.target.value);
    }

    render() {
        return (
            <div className="searchbar-container">
                <input type="text" className="searchbar" onChange={this.inputChanged} placeholder='Search...' value={this.state.input} ></input>
            </div>
        );
    }
}

SearchBar.propTypes = {
    inputChanged: PropTypes.func.isRequired
};

const hoc = withRouter(SearchBar);

// EXPORT COMPONENT
export { hoc as SearchBar };


// WEBPACK FOOTER //
// ./src/components/containers/SearchBar.js